import React, { useEffect, useState } from "react";
import RedioBox from "../../../../MainWebsiteComponent/RedioBox/RedioBox";
import AsAnOrganization from "../../../../MainWebsiteComponent/AsAnOrganization/AsAnOrganization";
import { Typography } from "@mui/material";
import AsAnIndividual from "../../../../MainWebsiteComponent/AsAnIndividual/AsAnIndividual";
import styles from "./BasicInfo.module.css";
import { Provider, useDispatch, useSelector } from "react-redux";
//import store actions
import * as actions from "../../../../MainWebsiteComponent/store/actions";
import store from "../../../../MainWebsiteComponent/store";
import { useRouter } from "next/router";

const BasicInfo = (props) => {
  const {
    userInfo
  } = props
  const dispatch = useDispatch();
  const router = useRouter();
  const [radioButtonSteps, setRadioButtonSteps] = useState(
    useSelector((state) => state.teachingType)
  );
  
  const onChange = (event, newValue) => {

    setRadioButtonSteps(newValue);
    dispatch(actions.setTeachingType(newValue));
    
    if(newValue == 0){
      dispatch(actions.setFirstName(''))
      dispatch(actions.setLastName(''))
    }else{
      dispatch(actions.setOrgFullName(''))
    }
  };

  const { account_type } = router.query;

  useEffect(() => {
    if(account_type && account_type != ""){
      if(account_type == "organization"){
        setRadioButtonSteps(0)
        dispatch(actions.setTeachingType(0));
        dispatch(actions.setFirstName(''))
        dispatch(actions.setLastName(''))
      }else{
        setRadioButtonSteps(1)
        dispatch(actions.setTeachingType(1));
        dispatch(actions.setOrgFullName(''))

      }
    }
  },[account_type])

  const tabsData = [
    {
      title: "As an Organization",
      description: "Courses will be published on behalf of your organization.",
    },

    {
      title: "As an Individual",
      description: "Courses will be published on behalf of you.",
    },
  ];

  const panelDate = [
    {
      id: 0,
      panel: (
        <Provider store={store}>
          <AsAnOrganization loggedInUserInfo={userInfo}/>
        </Provider>
      ),
    },

    {
      id: 1,
      panel: (
        <Provider store={store}>
          <AsAnIndividual loggedInUserInfo={userInfo}/>
        </Provider>
      ),
    },
  ];

  return (
    <div className="StepperContentSection">
      <div className={styles.MdTitle}>Basic Info</div>
      <div>
        <p style={{ color: "#676C7B", margin: "0 0 5px 0" }}>
          How are you planing to teach?
        </p>
        <RedioBox
          tabsData={tabsData}
          panelDate={panelDate}
          value={radioButtonSteps}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default BasicInfo;
